import { useState, useEffect } from 'react';

const deepFilter = (item, searchTerm) => {
  const term = searchTerm.toLowerCase();

  return Object.values(item).some((value) => {
    if (value === null) {
      return false;
    }

    if (typeof value === 'string') {
      return value.toLowerCase().includes(term);
    }

    if (typeof value === 'object') {
      return deepFilter(value, searchTerm);
    }

    return false;
  });
};

const useDeepFilter = (data) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDataByInput, setFilteredDataByInput] = useState([]);

  useEffect(() => {
    const filteredArray = data.filter((item) => deepFilter(item, searchTerm));
    setFilteredDataByInput(filteredArray);
  }, [data, searchTerm]);

  return { filteredDataByInput, searchTerm, setSearchTerm };
};

export default useDeepFilter;
